import { z } from 'zod';
import { ProductSchema } from '../models';

export const PublicProductsResponseSchema = z.object({
  entries: z.array(ProductSchema),
  total: z.number(),
});

export type PublicProductsResponse = z.infer<typeof PublicProductsResponseSchema>;
